(ns ncr.backend-http
  (:refer-clojure :exclude [get])
  (:require
   [clojure.core.match :refer [match]]
   [clojure.string :as str]
   [cljs.core.async :as async :refer-macros [go]]
   [cljs-http.client :as http]
   [ncr.etc.modal :as m]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.pf :as pf]))

(defn- not-available [banner]
  (go
    (<!
      (m/!alert
        {:title "NECKAR Not Available"
         :show-close false
         :body banner
         :actions
         [[pf/c-button
           {:variant :primary
            :on-click #(.reload js/location)} "Reload"]]}))))

(defn use-available []
  @(ps/sub-reducer-map! [:available]
     {::not-available
      (fn [_ response]
        (not-available
          (let [body (:body response)]
            (if-not (str/blank? body)
              (str body)
              "API Status Response: 503")))
        [:not-available])}))

(defn- request [rfn url props]
  (go
    (let [response (<! (rfn url props))]
      (match response
        {:success false :status 503}
        (ps/pub! [::not-available response])

        _
        nil)
      response)))

(def get
  (partial request http/get))

(def post
  (partial request http/post))

